import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { DivisionInfo } from '../model/division.model';
import { TimeSheetChecklistMonthInfo } from '../model/timesheetChecklist.model';
import { EmpInfo } from '../model/emp.model';

@Component({
  selector: 'app-timesheet-checklist-month',
  templateUrl: './timesheet-checklist-month.component.html',
  styleUrls: ['./timesheet-checklist-month.component.css']
})
export class TimesheetChecklistMonthComponent implements OnInit {

  baseurl: string;
  _ForK2: string;
  _EmpCode: string;
  _TimeSheetDate: string;
  _ByOrgcode: boolean = false;

  //Primary data
  modelOnPromise: Promise<TimeSheetChecklistMonthInfo[]>
  modelList: TimeSheetChecklistMonthInfo[] = [];
  modelEmployee: EmpInfo[] = [];

  //Search Conditions
  ListDivision: DivisionInfo[] = [];
  isSearchSubmitted: boolean = false;
  txtSchDivision: string = "";

  //Pagination variable
  public indexNo: number = 0;
  public currentPageNumber: number;
  public itemTotal: any;
  public totalPages: number;
  public pagesize: number = 15;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private location: Location, private activatedRoute: ActivatedRoute) { 
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;

    this._TimeSheetDate = this.activatedRoute.snapshot.params.TimeSheetDate;

    this._ByOrgcode = this.activatedRoute.snapshot.params.ByOrgcode;
   

    GlobalService.CheckPagingAccessRights();
  }

  //============================ ngOnInit [Start] ===============================================
  async ngOnInit() {
    this._EmpCode = localStorage.getItem("EmpCode");

    if(this._TimeSheetDate == null || this._TimeSheetDate == ""){
      alert("Invalid date parameter, please try again.")
      this.location.back()
    }

    this.currentPageNumber = 1;

    if (this._ByOrgcode) {
      await this.LoadEmployee().then(
        data => {
          this.modelEmployee = data;
        }
      )
    } 

    this.LoadData();
    this.LoadDivision().then((data) => {
      this.ListDivision = data;
    });
  }
  //============================ ngOnInit [End] ===============================================

  //============================ onEvent [Start] ===============================================
  btnClick_setfilter() {
    this.isSearchSubmitted = true;
    this.LoadData();
  }
  btnClick_unsetFilter() {
    this.txtSchDivision = "";
    this.isSearchSubmitted = false;
    this.LoadData();
  }
  //============================ onEvent [End] ===============================================

  //============================ Data Loading [Start] =========================================
  LoadData() {
    this.getTimesheetChecklist()
      .then(
        data => {
          this.modelList = data;
          this.itemTotal = (this.modelList.length != 0) ? data[0].rowTotal : 0;
        }
      ).then(() => {
        if (this.itemTotal == 0) {
          this.currentPageNumber = 0;
        }
        this.totalPages = Math.ceil(this.itemTotal / environment.PageSize)
      })
  }

  async getTimesheetChecklist(): Promise<TimeSheetChecklistMonthInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * this.pagesize;

      var objectjson = {}; 

      if (this.isSearchSubmitted) objectjson['OnlyWithPending'] = 1;
      objectjson['DivisionCode'] = this.checkUndefinedString(this.txtSchDivision);
      objectjson['TimeSheetDate'] = this.checkUndefinedString(this._TimeSheetDate);
      objectjson['rowFetch'] = this.pagesize;
      objectjson['rowOFFSet'] = offset;
      if (this.modelEmployee.length != 0) objectjson['ByOrgcode'] = this.modelEmployee[0].OrganizationCode;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson)

      this.modelOnPromise = this.httpClient
        .post<TimeSheetChecklistMonthInfo[]>(this.baseurl + "TimeSheet/GetChecklistTimesheetByMonth",
          strjson, httpOptions)
        .toPromise()

      return this.modelOnPromise;
    }
  }

  async LoadDivision() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<DivisionInfo[]>(this.baseurl + "Division/GetDivision", strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadEmployee(): Promise<EmpInfo[]> {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //Set post param
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['EmpCode'] = this._EmpCode;

      let strjson = JSON.stringify(objectjson);

      try {
        const data = await this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions).toPromise();
        return data;

      } catch (error) {
        console.error(error);
      }
    }
  }
   //============================ Data Loading [End] =========================================

  //============================ Misc Functions [Start] =========================================
  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput;

  }
  //============================ Misc Function [End] =========================================

  //============================ Pagination [Start] =========================================
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;
  }

  OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
      this.LoadData();
    }
  }
  //============================ Pagination [End] =========================================
}
